import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import { SlHome } from "react-icons/sl";
import { SlArrowRight } from "react-icons/sl";
import { getAllAgentUserDetailsList } from '../../serverApi/server'

const AllReferralAgents = () => {
  const [allReferralAgentsList, setAllReferralAgentsList] = useState([])
  const [filterMonthYear, setFilterMonthYear] = useState('');

  const fetchAllAgentsUser = async (filterYear) => {
    try {
      const getAllAgentUserDetailsListAPIResponse = await getAllAgentUserDetailsList(filterYear);
      let agentsList = getAllAgentUserDetailsListAPIResponse.data.total_referral_user_details;
      agentsList = agentsList.sort((a, b) => (b.total_orders || 0) - (a.total_orders || 0));
      setAllReferralAgentsList(agentsList)
    } catch (error) {
      console.error('Error fetching sub-menus:', error);
    }
  };

  useEffect(() => {
    var currentMonthYear = null
    fetchAllAgentsUser(currentMonthYear);
  }, []);

  const handleMonthYear = async (e) => {
    setFilterMonthYear(e.target.value)
    fetchAllAgentsUser(e.target.value);
  }

  return (
    <div className="flex w-full h-screen">
      <div className="fixed h-full custom-scroll">
        <SideBar />
      </div>
      <div className="ml-64 flex-1 overflow-y-auto">
        <Header />
        <div className="bg-[#F5F7FD] px-7 py-6">
          <div className="flex items-center justify-between">
            <div className="text-blue-950 flex items-center gap-6">
              <h1 className="pr-6 text-2xl font-medium border-r">
                Admin Users
              </h1>
              <div className="flex text-sm items-center gap-3">
                <button>
                  <SlHome />
                </button>
                <SlArrowRight />
                <button>
                  Referral
                </button>
                <SlArrowRight />
                <button>
                  View Referral Agents
                </button>
              </div>
            </div>
          </div>

          <div className='bg-white mt-10 px-3 py-4 rounded-lg'>
            <div className='px-5 md:px-7 pt-4 flex items-center justify-between gap-2'>
              <div className='flex items-center gap-1 font-light'>
                <p className='text-neutral-700'>show</p>
                <select name="entries" className='border text-sm rounded-md focus:outline-none'>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <p className='text-neutral-700'>entries</p>
              </div>

              <div className="flex flex-col">
                <input type='month' id="dateInput" value={filterMonthYear} onChange={handleMonthYear} style={{ backgroundColor: '#cde6fd', borderRadius: '7px', padding: '6px' }} />
              </div>

              {/* <div style={{ display: 'flex', height: '28px' }}>
                <input type="date" id="dateInput" value={estDate} onChange={handleDateChange} style={{ marginRight: '20px', backgroundColor: '#cde6fd', padding: '19px', borderRadius: '10px' }} />
                <form className='flex items-center gap-1 font-light'>
                  <label htmlFor="entries-search" className='text-neutral-700'>Search:</label>
                  <input type="text" className='border-2 w-auto sm:w-40 text-sm px-2 py-[2px] rounded focus:outline-none'/>
                </form>
              </div> */}
            </div>
            <div className="overflow-x-auto table-auto">
              <table className="min-w-full bg-white mt-8" style={{ borderCollapse: 'separate', borderSpacing: '2px' }}>
                <thead>
                  <tr>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">AGENT NAME</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">REFERRAL NUMBER</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">TOTAL ORDERS</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">DISCOUNT AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {allReferralAgentsList.length > 0 ? (
                      allReferralAgentsList.map((referralUser) => (
                      <tr key={referralUser.id}>

                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.agent_name}</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.agent_referral_code}</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.total_orders}</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.discount_amount ? parseFloat(referralUser.discount_amount).toFixed(2) : ''}</td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="px-4 py-6 text-center text-neutral-600">
                        No agents available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllReferralAgents;
